import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface Source {
  id: string;
  name: string;
  slug: string;
  homepage_url: string;
  sitemap_url: string | null;
  logo_url: string | null;
}

interface SourcesResponse {
  data: Source[];
  pagination: { limit: number; offset: number; count: number };
}

export function useSources() {
  return useQuery({
    queryKey: ['sources'],
    queryFn: async () => {
      const response = await apiClient.get<SourcesResponse>('/sources');
      return response.data;
    },
  });
}

export function useUpdateSource() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: Partial<Source> }) => {
      return apiClient.patch<Source>(`/sources/${id}`, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sources'] });
      queryClient.invalidateQueries({ queryKey: ['sitemaps'] });
    },
  });
}

export function useCreateSource() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { name: string; homepage_url: string; sitemap_url?: string }) => {
      return apiClient.post<Source>('/sources', data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sources'] });
      queryClient.invalidateQueries({ queryKey: ['sitemaps'] });
    },
  });
}
